var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "review-wrap" }, [
    _c("div", { staticClass: "review-main" }, [
      _c("div", { staticClass: "review-left" }, [
        _c("div", { staticClass: "review-left__head" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("home.pendingReview")) +
                " (" +
                _vm._s(_vm.pendingList.length) +
                ")"
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "review-left__list" },
          [
            _vm._l(_vm.pendingList, function (item, index) {
              return _c(
                "div",
                {
                  key: item.id,
                  class: [
                    "review-item",
                    _vm.isActive(item) ? "review-item--active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.selectRow(item, index)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "review-item__thumb" }, [
                    _vm.getItemThumb(item)
                      ? _c("img", { attrs: { src: _vm.getItemThumb(item) } })
                      : _c("i", {
                          staticClass:
                            "el-icon-picture-outline review-item__thumb-icon",
                        }),
                  ]),
                  _c("div", { staticClass: "review-item__info" }, [
                    _c("div", { staticClass: "review-item__no" }, [
                      _vm._v(_vm._s(item.waybillNumber || "--")),
                    ]),
                    _c("div", { staticClass: "review-item__sub" }, [
                      _vm._v(_vm._s(item.preDeliverSiteIdName || "--")),
                    ]),
                    _c("div", { staticClass: "review-item__sub" }, [
                      _vm._v(_vm._s(item.uploadTime || "--")),
                    ]),
                  ]),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.statusTagType(item.forceType),
                        size: "mini",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.statusText(item.forceType)) + " ")]
                  ),
                ],
                1
              )
            }),
            !_vm.pendingList.length
              ? _c("div", { staticClass: "review-left__empty" }, [_vm._v("--")])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "review-right" }, [
        _c("div", { staticClass: "review-right__head" }, [
          _c("span", { staticClass: "review-right__head-title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("home.reviewPackage")) +
                " " +
                _vm._s(_vm.displayPosition) +
                " / " +
                _vm._s(_vm.pendingList.length) +
                " "
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.prevDisabled, size: "small" },
                  on: { click: _vm.goPrev },
                },
                [_vm._v(" " + _vm._s(_vm.$t("home.prevOne")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.nextDisabled, size: "small" },
                  on: { click: _vm.goNext },
                },
                [_vm._v(" " + _vm._s(_vm.$t("home.nextOne")) + " ")]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "review-right__body" }, [
          _c("div", { staticClass: "review-card" }, [
            _c("div", { staticClass: "review-card__title" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("newOrder.waybillNumber")) +
                    ": " +
                    _vm._s(_vm.currentRow.waybillNumber || "--")
                ),
              ]),
              _vm.currentRow.waybillNumber
                ? _c("i", {
                    staticClass: "el-icon-document-copy review-card__copy",
                    on: { click: _vm.copyWaybillNumber },
                  })
                : _vm._e(),
            ]),
            _c("div", { staticClass: "review-card__cols" }, [
              _c("div", { staticClass: "review-card__col" }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("GlobalSetObj.preEntrega")) + ":"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.currentRow.preDeliverSiteIdName || "--")),
                  ]),
                ]),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("orderCenterCont.deliveryPerson")) + ":"
                    ),
                  ]),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.currentRow.delivererName || "--")),
                  ]),
                ]),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.ReceivingAddress")) + ":"
                    ),
                  ]),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.currentRow.receiveAddr || "--")),
                  ]),
                ]),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("orderCenterCont.HouseNumber")) + ":"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.currentRow.receiveHouseNumber || "--")),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "review-card__col" }, [
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("home.recipient")) + ":"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [_vm._v("--")]),
                ]),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("home.contactPhone")) + ":"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [_vm._v("--")]),
                ]),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("home.customer")) + ":"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [_vm._v("--")]),
                ]),
                _c("div", { staticClass: "info-item" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.$t("home.merchant")) + ":"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [_vm._v("--")]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "review-card review-card--photos" }, [
            _c(
              "div",
              { staticClass: "review-photo-block review-photo-block--photo" },
              [
                _c("div", { staticClass: "review-photo-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("home.signedPhoto")) +
                      " (" +
                      _vm._s(_vm.photoList.length) +
                      ") "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "review-photo-list" },
                  [
                    _vm._l(_vm.photoList, function (url, i) {
                      return _c(
                        "el-image",
                        {
                          key: "photo" + i,
                          staticClass: "review-photo",
                          attrs: {
                            "preview-src-list": [url],
                            src: _vm.getImgUrl(url, 800, 800),
                            fit: "cover",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-picture-outline",
                              }),
                            ]
                          ),
                        ]
                      )
                    }),
                    !_vm.photoList.length
                      ? _c("span", [_vm._v("--")])
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "review-photo-block review-photo-block--sign" },
              [
                _c("div", { staticClass: "review-photo-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("home.signedNamePhoto")) +
                      " (" +
                      _vm._s(_vm.signList.length) +
                      ") "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "review-photo-list" },
                  [
                    _vm._l(_vm.signList, function (url, i) {
                      return _c(
                        "el-image",
                        {
                          key: "sign" + i,
                          staticClass: "review-photo",
                          attrs: {
                            "preview-src-list": [url],
                            src: _vm.getImgUrl(url, 800, 800),
                            fit: "cover",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-picture-outline",
                              }),
                            ]
                          ),
                        ]
                      )
                    }),
                    !_vm.signList.length
                      ? _c("span", [_vm._v("--")])
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]),
          _vm.showReviewArea
            ? _c("div", { staticClass: "review-card" }, [
                _c("div", { staticClass: "result-row" }, [
                  _c("span", { staticClass: "result-label" }, [
                    _vm._v(_vm._s(_vm.$t("home.appliveResult")) + ":"),
                  ]),
                  _c("div", { staticClass: "result-btns" }, [
                    _c(
                      "div",
                      {
                        staticClass: "result-btn result-btn--pass",
                        on: { click: _vm.choosePass },
                      },
                      [
                        _c("i", { staticClass: "el-icon-check" }),
                        _c("span", [_vm._v(_vm._s(_vm.$t("home.pass")))]),
                      ]
                    ),
                    _vm.canReview
                      ? _c(
                          "div",
                          {
                            class: [
                              "result-btn",
                              "result-btn--fail",
                              _vm.formInline.auditsState === 0
                                ? "is-active"
                                : "",
                            ],
                            on: { click: _vm.chooseFail },
                          },
                          [
                            _c("i", { staticClass: "el-icon-close" }),
                            _c("span", [_vm._v(_vm._s(_vm.$t("home.noPass")))]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm.canReview && _vm.formInline.auditsState === 0
                  ? _c("div", { staticClass: "reason-row" }, [
                      _c("span", { staticClass: "result-label" }, [
                        _vm._v(_vm._s(_vm.$t("home.failReason")) + ":"),
                      ]),
                      _c("div", { staticClass: "reason-list" }, [
                        _c(
                          "div",
                          {
                            class: [
                              "reason-item",
                              _vm.formInline.photoFail ? "is-active" : "",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.toggleReason("photo")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-picture-outline reason-item__icon",
                            }),
                            _c("div", { staticClass: "reason-item__text" }, [
                              _c("div", { staticClass: "reason-item__name" }, [
                                _vm._v(_vm._s(_vm.$t("home.photoStandard"))),
                              ]),
                              _c("div", { staticClass: "reason-item__desc" }, [
                                _vm._v(_vm._s(_vm.$t("home.photoFailDesc"))),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            class: [
                              "reason-item",
                              _vm.formInline.signFail ? "is-active" : "",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.toggleReason("sign")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-edit-outline reason-item__icon",
                            }),
                            _c("div", { staticClass: "reason-item__text" }, [
                              _c("div", { staticClass: "reason-item__name" }, [
                                _vm._v(_vm._s(_vm.$t("home.signStandard"))),
                              ]),
                              _c("div", { staticClass: "reason-item__desc" }, [
                                _vm._v(_vm._s(_vm.$t("home.signFailDesc"))),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _c(
                "div",
                { staticClass: "review-card review-card--reviewed" },
                [
                  _c("span", { staticClass: "result-label" }, [
                    _vm._v(_vm._s(_vm.$t("home.appliveResult")) + ":"),
                  ]),
                  _c("el-tag", { attrs: { size: "small", type: "success" } }, [
                    _vm._v(_vm._s(_vm.$t("home.reviewedTag"))),
                  ]),
                ],
                1
              ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "review-footer" },
      [
        _c(
          "el-button",
          { attrs: { size: "small" }, on: { click: _vm.closeDrawer } },
          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Close")))]
        ),
        _c(
          "div",
          { staticClass: "review-footer__right" },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.autoNext,
                  callback: function ($$v) {
                    _vm.autoNext = $$v
                  },
                  expression: "autoNext",
                },
              },
              [_vm._v(_vm._s(_vm.$t("home.autoEnterNext")))]
            ),
            _vm.canReview
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.formInline.auditsState === "",
                      size: "small",
                      type: "primary",
                    },
                    on: { click: _vm.confirmAndNext },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("home.confirmAndNext")) + " ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }